import { Component, OnInit, ViewChild } from '@angular/core';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { GeneralService } from '../services/general.service';
import { Router } from '@angular/router';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';

@Component({
  selector: 'app-avt-liste-cursus',
  templateUrl: './avt-liste-cursus.component.html',
  styleUrls: ['./avt-liste-cursus.component.scss']
})
export class AvtListeCursusComponent implements OnInit {

  constructor(public dialog: MatDialog,public router:Router,public generalService:GeneralService) { }
  exist : boolean = true;
  disableBtnAjouter : boolean = false;
  // cursus;
  // initCursus;
  listeCursus = [];
  listBtn:Array<any> = 
  [
    {name:"modifier",class:"colorBlue",text:"Modifier",disabled:false,icon:"edite"},
    {name:"consulter",class:"colorGray",text:"Consulter",disabled:false,icon:"import_contacts"},
    {name:"supprimer",class:"colorRed",text:"Supprimer",disabled:false,icon:"delete"}
  ]
  columns=
  {
    "TableRD":
    [
      {"TableRE_Code":"","TableRD_Champs":"Cursus_Code","Lg_Code":"","TableRD_Des":"Code","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"dd-MM-yyyy","TableRD_Alligement":0,"TableRD_Ordre":1,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"Cursus_Titre","Lg_Code":"","TableRD_Des":"Cursus","TableRD_Largeur":200,"TableRD_ReadOnly":true,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"Cursus_Duree","Lg_Code":"","TableRD_Des":"Durée","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":null,"TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null}
    ]
  }
  @ViewChild("listeCursusComponen",{static:false}) listeCursusComponen : AvtListesComponent;
  ngOnInit() 
  {
    // this.cursus = {}
    // this.getInitCursus();
    this.getListeCursus();
  }
  // getInitCursus()
  // {
  //   this.generalService.rechercheTable(this.generalService.urlApplyCursus).subscribe(cursus =>
  //   {
  //     this.initCursus = cursus;
  //     this.cursus = cursus.ApplyCursus[0];
  //   })
  // }
  getListeCursus()
  {
    this.generalService.rechercheTable(this.generalService.urlListeApplyCursus).subscribe(cursus =>
    {
      this.listeCursus = cursus;
      this.listeCursusComponen.setDataSource(this.listeCursus);
      this.listeCursusComponen.rows = []
    })
  }
  openFrmModifierCursus()
  {
    if(this.listeCursusComponen.rows != undefined && this.listeCursusComponen.rows.length == 1)
    {
      if(this.generalService.isNotEmpty(this.listeCursusComponen.rows[0]))
        this.generalService.popupCenter("/w/avt/cursus" + "/" + this.listeCursusComponen.rows[0].Cursus_Code + "/" + "2");
      else
        this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données",false);
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une seule ligne",false)
  }

  clickBtnHeat(event)
  {
    switch (event.name)
    {
      case "modifier":
      {
        this.openFrmModifierCursus()
        break;
      }
      
      case "supprimer":
      {
        this.supprimer()
        break;
      }
      case "consulter":
      {
        this.gotToCursus();
        break;
      }
    }
  }
  gotToCursus()
  {
    if(this.listeCursusComponen.rows != undefined && this.listeCursusComponen.rows.length == 1)
    {
      if(this.generalService.isNotEmpty(this.listeCursusComponen.rows[0]))
        this.router.navigate(['avt/cursus',this.listeCursusComponen.rows[0].Cursus_Code,"3"]);
      else
        this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données",false);
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une seule ligne",false)
  }

  supprimer()
  {
    if(this.listeCursusComponen.rows != undefined && this.listeCursusComponen.rows.length > 0)
    {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          var compt = this.listeCursusComponen.rows.length;
          this.exist = false;
          this.listBtn[1].disabled = true;
          this.listeCursusComponen.rows.forEach(row =>
          {
            var deleteFn = this.generalService.supprimerSanMsgConfirm(row.Cursus_Code,"ApplyCursus");
            if(deleteFn != null)
            {
              deleteFn.subscribe(data => 
              {
                compt--
                if(compt == 0)
                {
                  this.getListeCursus();
                  this.exist = true;
                  this.listBtn[1].disabled = false;
                }
                this.generalService.dialogSuccess("Elément supprimer",true);
              },
              error =>
              {
                  this.generalService.dialogSuccess("Elément non supprimé",false);
                  this.exist = true;
                  this.listBtn[1].disabled = false;
              });
            }
          });
          
        }
        if(result == "annuler")
        {
        }
      });
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une ou plusieurs lignes",false)
  }
}
